$(document).ready(function() {
  $('.product__description').each(function() {
    var $desc = $(this);$desc.addClass('expanded');
    var fullHeight = $desc.prop('scrollHeight');
    
    // Insert toggle button after description
    //on/Off knapp, $desc.after('<div class="toggle-description">Show More</div>');

    // Click handler
    $desc.next('.toggle-description').on('click', function() {
      if ($desc.hasClass('expanded')) {
        $desc.removeClass('expanded');
        $(this).text('Show More');
      } else {
        $desc.addClass('expanded');
        $(this).text('Show Less');
      }
    });
  });

});